import React from "react";
import {translate} from "../../../vendors/react-translate/ReactTranslate";
import OnBoardService from "../onboard-service";
import OnBoardSmsSender from "../components/onboard-sms";
import OnBoardDoneStep from "../components/onboard-done-step";
class OnBoardStep4 extends React.Component {
  renderStep() {
    const { stepData, onComplete, accountId, isMobile, language } = this.props;
    const email = stepData.stepData.email.value;
    const phone = stepData.stepData.phone.value;
    const hasPhone = phone && phone.lineNumber;
    let elem;
    let isSms = false;

    if ((email && hasPhone) || (!email && hasPhone)) {
      elem = (
        <OnBoardDoneStep
          hasEmail={!!email}
          isMobile={isMobile}
          onComplete={onComplete}
        />
      );
    } else if (email && phone.length === 0) {
      const countryCode = OnBoardService.getCountryCode();
      isSms = true;
      elem = (
        <OnBoardSmsSender
          stepData={stepData}
          accountId={accountId}
          countryCode={countryCode}
          language={language}
          isMobile={isMobile}
          onComplete={onComplete}
        />
      );
    }
    return { elem, isSms };
  }

  render() {
    const {elem, isSms} = this.renderStep();
    return <div className="item-row onboard-step" style={isSms ? {paddingTop: 0} : {}}> {elem}</div>;
  }
}

export default translate("onboarding")(OnBoardStep4);
